/* global grecaptcha */
import BaseForm from '@modules/baseForm'
import textfield from '@magnetita/textfield'
import messenger from '@modules/messenger'

import {
  dispatch,
  getDispatchLoader
} from '@modules/dispatchForm'

const apiAcronym = {
  login: '/account/api/login',
  register: '/account/api/register'
}

const formAcronym = {
  login: '#js-signin-form',
  register: '#js-signup-form'
}

class Signin extends BaseForm {
  constructor ({ type, stage }) {
    super({ target: formAcronym[type] })

    this.api = apiAcronym[type]
    this.stage = stage
    this.recaptcha = apiAcronym[type] === '/account/api/register'

    /**
     * add events
     */
    this.stageHandlerOnHidden = this.onHiddenStep.bind(this)
    this.stage.addEventListener(
      'step-on-hidden',
      this.stageHandlerOnHidden,
      false
    )

    if (this.recaptcha) {
      window.onsignup = this.request.bind(this)

      /**
       * force button pending status on recaptcha validate
       */
      this.onHandlerRecaptchaValidate = this.onRecaptchaValidate.bind(this)
      this.button = this.form.querySelector('button[type="submit"]')
      this.button.addEventListener('click', this.onHandlerRecaptchaValidate, false)
    }
  }

  onHiddenStep () {
    this.resetFormEvents()
    this.resetFormErrors()

    /**
     * remove [step-on-show, step-on-hidden] event after run resets
     */
    this.stage.removeEventListener(
      'step-on-hidden',
      this.stageHandlerOnHidden,
      false
    )

    if (this.recaptcha) {
      this.button.removeEventListener('click', this.onHandlerRecaptchaValidate, false)
    }
  }

  onRecaptchaValidate () {
    if (!this.validator.validate()) return

    getDispatchLoader({
      status: 'onrecaptcha',
      context: this.form,
      target: this.button
    })
  }

  validate () {
    this.instance.Password(this.validator)
  }

  request (token) {
    const body = new FormData(this.form)
    if (this.recaptcha) {
      if (!token) return
      body.append('recaptcha', token)
    }

    dispatch(this.form, body, this.api).then((data) => {
      if (!data) {
        messenger.show({ context: this.form })
        return
      }

      if (!data.success) {
        messenger.show({ context: this.form, message: data.message })
        return
      }

      window.location.href = '/account'
    })

    if (this.recaptcha) {
      /**
         * create new challenge
         */
      grecaptcha.reset()
    }
  }

  fillHiddenFieldWithEmail ({ email }) {
    this.form.elements.email.value = email
    this.recaptcha = this.recaptcha && !email.endsWith('-test@foregon.com')
  }

  resetFormErrors () {
    this.form.reset()
    this.validator.destroy()

    /**
     * remove dirty from <input> and
     * close message
     */
    textfield.reset(this.form.elements.password)
    messenger.close(this.form)
  }
}

export default Signin
